import { ReactDatePickerProps } from 'react-datepicker';
import styles from './styles.module.scss';

export const DatePickerCalendarContainer = ({
  children,
}: ReactDatePickerProps) => (
  <div className={styles.calendarContainer}>{children}</div>
);
